import type { ButtonHTMLAttributes } from "react";
import { forwardRef } from "react";
import classNames from "classnames/dedupe";
import { Icon, type DOMProps } from "@simplybusiness/mobius";
import { arrowUp } from "@simplybusiness/icons";

export type PromptInputSubmitElementType = HTMLButtonElement;
export type PromptInputSubmitRef = React.Ref<PromptInputSubmitElementType>;

export interface PromptInputSubmitProps
  extends
    Omit<DOMProps, "ref">,
    Omit<ButtonHTMLAttributes<HTMLButtonElement>, "className" | "type"> {
  /**
   * Custom class name
   */
  className?: string;
  /**
   * Loading/success status for visual feedback
   */
  status?: "ready" | "loading" | "success";
}

const PromptInputSubmit = forwardRef<
  PromptInputSubmitElementType,
  PromptInputSubmitProps
>((props: PromptInputSubmitProps, ref: PromptInputSubmitRef) => {
  const { className, status: _status = "ready", ...otherProps } = props;

  const classes = classNames("mobius-prompt-input__submit", className);

  return (
    <button ref={ref} {...otherProps} type="submit" className={classes}>
      <Icon icon={arrowUp} />
    </button>
  );
});

PromptInputSubmit.displayName = "PromptInputSubmit";
export { PromptInputSubmit };
